import { render, staticRenderFns } from "./fireFightingPermitDetail.vue?vue&type=template&id=6cfd2259&scoped=true"
import script from "./fireFightingPermitDetail.vue?vue&type=script&lang=js"
export * from "./fireFightingPermitDetail.vue?vue&type=script&lang=js"
import style0 from "./fireFightingPermitDetail.vue?vue&type=style&index=0&id=6cfd2259&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cfd2259",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6cfd2259')) {
      api.createRecord('6cfd2259', component.options)
    } else {
      api.reload('6cfd2259', component.options)
    }
    module.hot.accept("./fireFightingPermitDetail.vue?vue&type=template&id=6cfd2259&scoped=true", function () {
      api.rerender('6cfd2259', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/fft/permit/fireFightingPermitDetail.vue"
export default component.exports